import { OfferEventData, PostToParentEventData } from '../interfaces/interface.post-to-parent';
import EventBus from '../services/service.eventBus';
import { state as answerState } from '../store/store.answers';
import { state as customerState } from '../store/store.customer';
import { state as offerVehicleState } from '../store/store.offer-vehicle';
import { state as supplementState } from '../store/store.supplement';
import { hashEmailSHA256 } from '../utils/utils.email-hash';
import { generateFTID } from '../utils/utils.ftid';
import { getReplacementVehicleData } from '../utils/utils.replacement-vehicle-mapping';

let currentFTID: string | null = null;

export const getCurrentFTID = (offerId: string): string => {
  if (!currentFTID) {
    currentFTID = generateFTID(offerId);
  }
  return currentFTID;
};

export const onOfferSubmissionComplete = (eventData: OfferEventData): PostToParentEventData => {
  try {
    // Use prospect data from API response instead of potentially null state
    const prospect = eventData.prospectData;
    const contactInfo = prospect?.contactInfo;
    const vehicle = prospect?.vehicle;
    const vehicleDescription = vehicle?.vehicleDescription;

    // Get trade-in vehicle data with fallbacks to state
    const email = contactInfo?.email || customerState.email;
    const vehicleYear = vehicleDescription?.year || offerVehicleState.yearId?.toString();
    const vehicleMake = vehicleDescription?.make || offerVehicleState.make;
    const vehicleModel = vehicleDescription?.model || offerVehicleState.model;

    const hashedEmail = email ? hashEmailSHA256(email) : undefined;

    // Get replacement vehicle data directly
    const replacementVehicleData = getReplacementVehicleData(
      answerState.replacementVehicle || [],
      supplementState.makesModels?.values || [],
      supplementState.replacementVehicleOptions
    );

    return {
      type: 'CustomTagEvent',
      eventName: 'submit',
      eventAction: 'form',
      attributes: {
        formType: 'trade in',
        displayType: 'iFrame', // Can be "iFrame", "modal", or "inPage"
        formDescription: 'lead',
        displayFormat: '', // Will be set by Fury based on implementation
        leadId: getCurrentFTID(eventData.offerId),
        tradeInProvider: 'kbb',
        tradeInVehicleYear: vehicleYear,
        tradeInVehicleModel: vehicleModel,
        tradeInVehicleMake: vehicleMake,
        desiredVehicleModel: replacementVehicleData.desiredVehicleModel,
        desiredVehicleMake: replacementVehicleData.desiredVehicleMake,
        desiredVehicleYear: replacementVehicleData.desiredVehicleYear,
        hashedEmail,
      },
    };
  } catch (error) {
    console.error('Error preparing post-to-parent data:', error);
    EventBus.publish('PostToParentError', {
      type: 'Error',
      error: error.message,
    });
  }
};

const actions = {
  onOfferSubmissionComplete,
};

export default actions;
